import { useDeleteTranscriptMomentMutation, useStarTranscriptQuoteMutation } from '@/utils/api';
import { DeleteMomentContext, StarQuoteContext } from '@trinity/chat-components/containers/Transcript/context.js';

export const TranscriptGoodQuoteCompatContainer = (props: ChildrenProps) => {

  const { mutateAsync: starQuote } = useStarTranscriptQuoteMutation();
  const { mutateAsync: deleteMoment } = useDeleteTranscriptMomentMutation();

  return (
    <StarQuoteContext.Provider value={starQuote}>
      <DeleteMomentContext.Provider value={deleteMoment}>
        {props.children}
      </DeleteMomentContext.Provider>
    </StarQuoteContext.Provider>
  );
};